import { Badge, BadgeVariantEnum } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

type ReliabilityInlineBadgeProps = {
  isManual: boolean;
  className?: string;
};
export function ReliabilityInlineBadge({ isManual, className }: ReliabilityInlineBadgeProps) {
  const { t } = useTranslation();
  return (
    <Badge className={className} variant={BadgeVariantEnum.DefaultFilled}>
      {isManual ? t('Manual') : t('Automática')}
    </Badge>
  );
}
